// extracted by mini-css-extract-plugin
export default {"formContent":"MIRelationshipForm_formContent__1tgTE"};